export default __webpack_public_path__ + "static/media/breakfast.1f7aa4bd.svg";